var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import StripeForm from "./StripeForm";
import StripeWrapper from "./StripeWrapper";
var StripeCheckout = function (props) {
    return (React.createElement(StripeWrapper, { context: props.context, clientId: props.clientId },
        React.createElement(StripeForm, __assign({}, props))));
};
export default StripeCheckout;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUssTUFBTSxPQUFPLENBQUM7QUFFMUIsT0FBTyxVQUErQixNQUFNLGNBQWMsQ0FBQztBQUMzRCxPQUFPLGFBQWEsTUFBTSxpQkFBaUIsQ0FBQztBQUU1QyxJQUFNLGNBQWMsR0FBOEIsVUFBQyxLQUFLO0lBQ3RELE9BQU8sQ0FDTCxvQkFBQyxhQUFhLElBQUMsT0FBTyxFQUFFLEtBQUssQ0FBQyxPQUFPLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRO1FBQzdELG9CQUFDLFVBQVUsZUFBSyxLQUFLLEVBQUksQ0FDWCxDQUNqQixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsZUFBZSxjQUFjLENBQUMifQ==